<template>
    <div class="scroll-container" v-loading="isLoading">
        <div class="top-line search-line">
            <span class="sk-title-small content-center" style="flex: 1">文三街人流分析</span>
        </div>
        <div class="split-line"></div>
        <div class="top-line search-line">
            <div class="right"></div>
            <div class="left">
                <el-select v-model="searchParam.BizType" size="mini" style="margin-left: 20px" @change="onBizTypeChanged">
                    <el-option value="" label="全部业态">全部业态</el-option>
                    <el-option v-for="item in bizTypes" :value="item.ID" :key="item.ID" :label="item.Name">{{ item.Name }}</el-option>
                </el-select>
                <el-select v-model="searchParam.EntityID" size="mini" style="margin-left: 20px">
                    <el-option value="" label="全部实体">全部实体</el-option>
                    <el-option v-for="item in entityListFilter" :value="item.EntityID" :key="item.EntityID" :label="item.EntityName">{{
                        item.EntityName
                    }}</el-option>
                </el-select>

                <el-date-picker v-model="searchParam.BeginTime" size="mini" type="date" placeholder="选择日期"> </el-date-picker>
                <el-time-select v-model="searchParam.Time1" size="mini" start="00:00" step="01:00" end="24:00" class="timePicker"> </el-time-select>
                <el-time-select v-model="searchParam.Time2" size="mini" start="00:00" step="01:00" end="24:00" class="timePicker"> </el-time-select>
            </div>
            <div class="right">
                <input type="button" class="button-ok block-button" value="确定" @click="onSearch" />
            </div>
        </div>
        <!-- 查询条件 -->
        <div class="report-content">
            <div class="report-content-line">
                <Card>
                    <template v-slot:header>
                        <h2>分析结果</h2>
                    </template>
                    <div class="card-content">
                        <div class="chart-normal" ref="chart" style="padding-top: 20px">
                            <el-table :data="dataList" stripe style="width: 100%">
                                <el-table-column prop="Name" label="时间" sortable>
                                    <template v-slot="scope">
                                        <span style="color: #1080f2; font-weight: bolder">{{ scope.row.Name }} </span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="DataIn" label="进场总数 (人次)" sortable>
                                    <template v-slot="scope">
                                        {{ scope.row.DataIn }}
                                        <div class="progress">
                                            <div :style="getStyle(scope.row.DataIn, maxData.DataIn)"></div>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="DataOut" label="出场总数 (人次)" sortable>
                                    <template v-slot="scope">
                                        {{ scope.row.DataOut }}
                                        <div class="progress">
                                            <div :style="getStyle(scope.row.DataOut, maxData.DataOut)"></div>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="DataStay" label="在场人数 (人)" sortable>
                                    <template v-slot="scope">
                                        {{ scope.row.DataStay }}
                                        <div class="progress">
                                            <div :style="getStyle(scope.row.DataStay, maxData.DataStay)"></div>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="FlowDensity" label="人流密度 (人/㎡)" sortable>
                                    <template v-slot="scope">
                                        {{ scope.row.FlowDensity }}
                                        <div class="progress">
                                            <div class="checked" :style="getStyle(scope.row.FlowDensity, maxData.FlowDensity)"></div>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="StayTime" label="停留时间 (h/人)" sortable>
                                    <template v-slot="scope">
                                        {{ scope.row.StayTime }}
                                        <div class="progress">
                                            <div :style="getStyle(scope.row.StayTime, maxData.StayTime)"></div>
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </Card>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "sjfx",
    data() {
        return {
            bizTypes: [],
            entityList: [],
            entityListFilter: [],
            searchParam: {
                EntityID: "",
                BizType: "",
                BeginTime: "",
                Time1: "08:00",
                Time2: "21:00",
            },
            maxData: {
                DataIn: 100,
                DataOut: 100,
                DataStay: 100,
                FlowDensity: 5,
                StayTime: 5,
            },
            dataList: [],
        };
    },
    created() {
        this.loadBizTypes();
        this.loadEntitys();
        this.searchParam.BeginTime = new Date();
        this.onSearch();
    },
    methods: {
        onSearch() {
            this.$ajax.post("/FlowData/GetEntityTotalDate", this.searchParam).then((r) => {
                this.dataList = r.Data;
                for (var i = 0; i < this.dataList.length; i++) {
                    this.maxData.DataIn = Math.max(this.maxData.DataIn, this.dataList[i].DataIn);
                    this.maxData.DataOut = Math.max(this.maxData.DataOut, this.dataList[i].DataOut);
                    this.maxData.DataStay = Math.max(this.maxData.DataStay, this.dataList[i].DataStay);
                    this.maxData.FlowDensity = Math.max(this.maxData.FlowDensity, this.dataList[i].FlowDensity);
                    this.maxData.StayTime = Math.max(this.maxData.StayTime, this.dataList[i].StayTime);
                }
            });
        },
        onBizTypeChanged() {
            if (this.searchParam.BizType) {
                this.entityListFilter = this.entityList.filter((r) => r.BizTypeID == this.searchParam.BizType);
            } else {
                this.entityListFilter = [...this.entityList];
            }
        },
        loadBizTypes() {
            this.$ajax.post("/Entity/GetBizModels").then((r) => {
                this.bizTypes = r.Data;
            });
        },
        loadEntitys() {
            this.$ajax.post("/Entity/GetAllEntities").then((r) => {
                this.entityList = r.Data;
                this.entityListFilter = [...this.entityList];
            });
        },
        getStyle(d1, d2) {
            let wd = 0;
            if (d2 != 0) {
                wd = (d1 * 100) / d2;
            }
            return {
                width: wd + "%",
            };
        },
    },
};
</script>
<style scoped>
.progress {
    height: 10px;
    width: 60%;
    display: inline-block;
    margin-left: 20px;
}
.progress div {
    height: 10px;
    border-radius: 5px;
    float: left;
    display: inline;
    background-color: #4099f5;
}
.progress div.checked {
    height: 10px;
    border-radius: 5px;
    float: left;
    display: inline;
    background-color: #e49df6;
}
.timePicker {
    width: 100px;
}
.timePicker:first-child {
    margin-left: 10px;
}
</style>
